import React from "react";

const CreatePackage = React.lazy(() => import("./CreatePackage"));
const Index = React.lazy(() => import("./index"));
const DietPlanPackage = React.lazy(() =>
  import("../../components/DietPlanPackage")
);
const DietPlanPackageDetails = React.lazy(() =>
  import("./DietPlanPackageDetails")
);

export const dietPlanPackageRoutes = [
  {
    path: "/admin/dietPlanPackages",
    name: "Diet Plan Packages",
    element: <DietPlanPackage />,
  },
  {
    path: "/admin/dietPlanPackages/create",
    name: "Create Diet Plan Packages",
    element: <CreatePackage />,
  },
  {
    path: "/admin/dietPlanPackages/update/:id?",
    name: "Create Diet Plan Packages",
    element: <CreatePackage />,
  },
  {
    path: "/admin/dietPlanPackages/:id?",
    name: "Diet Plan Packages",
    element: <DietPlanPackageDetails />,
  },
];
